import type { GiftPassBundlePreviewResponse } from '@bonsai/shared';

import { BundleCostPriceRow } from './BundleCostPriceRow';

import './gift-pass-bundle-editor.css';

export interface BundleCostTableProps {
  preview: GiftPassBundlePreviewResponse;
  /** A newer preview is on its way. */
  loading: boolean;
}

export function BundleCostTable({ preview, loading }: BundleCostTableProps) {
  const campaignName = preview.campaign?.name ?? null;
  return (
    <>
      <table className="gpb-ed-cost-table" aria-busy={loading}>
        <thead>
          <tr>
            <th scope="col">Pass price</th>
            <th scope="col">Bundle</th>
            <th scope="col">Per pass</th>
          </tr>
        </thead>
        <tbody>
          {preview.prices.map((price) => (
            <BundleCostPriceRow
              key={`${price.basis}-${price.basePriceCents}`}
              price={price}
              campaignName={campaignName}
            />
          ))}
        </tbody>
      </table>
      <p className="gpb-ed-side-note">
        Ticket prices at public workshops in the next {preview.windowDays}{' '}
        {preview.windowDays === 1 ? 'day' : 'days'}
        {preview.campaign
          ? `, after ${preview.campaign.name} (${preview.campaign.discountLabel}).`
          : '.'}{' '}
        Saving changes future purchases only.
      </p>
    </>
  );
}
